import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { UserIcon, UsersIcon, CheckCircle2Icon } from 'lucide-react';
export function ResultsSection() {
  const forYou = [{
    text: 'Seguridad absoluta',
    highlight: ' para responder cada "¿por qué?"'
  }, {
    text: 'Ahorro de horas',
    highlight: ' en planificación'
  }, {
    text: 'Autoridad profesional',
    highlight: ''
  }];
  const forStudents = [{
    text: 'Resultados más rápidos',
    highlight: ' con técnica perfecta'
  }, {
    text: 'Confianza total',
    highlight: ' en tu trabajo'
  }, {
    text: 'Prevención real',
    highlight: ' de lesiones'
  }];
  return <section className="py-10 relative overflow-hidden bg-background" data-id="element-273">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-274">
        <FadeIn className="text-center mb-10" data-id="element-275">
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-gray-900" data-id="element-276">
            Lo que vas a lograr{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-277">
              vos y tus alumnos
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-278">
          <FadeIn delay={0.2} direction="up" data-id="element-279">
            <div className="bg-primary/5 border border-primary/20 rounded-2xl p-6 h-full" data-id="element-280">
              <div className="flex items-center gap-3 mb-4" data-id="element-281">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center" data-id="element-282">
                  <UserIcon className="w-5 h-5 text-primary" data-id="element-283" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-284">Para Vos</h3>
              </div>
              <ul className="space-y-3" data-id="element-285">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-286">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-287" />
                    <span className="text-gray-600" data-id="element-288">
                      <span className="text-gray-900 font-semibold" data-id="element-289">
                        {item.text}
                      </span>
                      {item.highlight}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="up" data-id="element-290">
            <div className="bg-green-50 border border-green-200 rounded-2xl p-6 h-full" data-id="element-291">
              <div className="flex items-center gap-3 mb-4" data-id="element-292">
                <div className="w-10 h-10 rounded-xl bg-green-100 flex items-center justify-center" data-id="element-293">
                  <UsersIcon className="w-5 h-5 text-green-600" data-id="element-294" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-295">
                  Para Tus Alumnos
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-296">
                {forStudents.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-297">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-298" />
                    <span className="text-gray-600" data-id="element-299">
                      <span className="text-gray-900 font-semibold" data-id="element-300">
                        {item.text}
                      </span>
                      {item.highlight}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}